
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M0 16A16 16 0 1016 0 16 16 0 000 16z","fill":"#f7fafc"}}),_c('path',{staticClass:"camera-ygt_svg__b",attrs:{"d":"M24.941 9.473h-2.619a.783.783 0 01-.729-.5l-.585-1.479a1.308 1.308 0 00-1.217-.827h-7.2a1.31 1.31 0 00-1.232.867l-.509 1.417a.785.785 0 01-.738.518H7.404a2.225 2.225 0 00-2.226 2.226v11.15a2.225 2.225 0 002.226 2.226h17.539a2.225 2.225 0 002.226-2.226v-11.15a2.226 2.226 0 00-2.228-2.222zm-8.77 12.171a5.061 5.061 0 115.061-5.061 5.066 5.066 0 01-5.061 5.061zm7.121-8.132a1.216 1.216 0 111.216-1.216 1.216 1.216 0 01-1.218 1.216z"}}),_c('path',{staticClass:"camera-ygt_svg__b",attrs:{"d":"M13.071 16.583a3.1 3.1 0 103.1-3.1 3.1 3.1 0 00-3.1 3.1z"}})])
          )
        }
      }
    